<template>
<div class="tagDialog" v-if="dialogVisible">
    <el-dialog @close='cancel' :title="'添加商品标签'" :visible.sync="dialogVisible" width="600px">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm form">
            <el-form-item label="标签名称" class="content">
                <div class="label">
                    <el-input v-model.trim="tag" placeholder="输入标签名称，不超过4个字" maxlength="4" clearable></el-input>
                    <el-button type="primary" @click="handelAdd">添加标签</el-button>
                </div>
            </el-form-item>
            <el-form-item label="自定义标签" class="content" v-if="taglist.length">
                <div class="taglist">
                    <span :class="'tag selected'" v-for="(obj,index) in taglist" :key="index"
                          @click="handelChange2(obj,index)">{{obj}}</span>
                </div>
            </el-form-item>
            <el-form-item label="常用标签" class="content">
                <div class="taglist">
                    <span :class="'tag '+[obj.isSelected?'selected':'']" v-for="(obj,index) in spellTipList"
                          :key="index" @click="handelChange(obj,index)">{{obj.name}}</span>
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
export default {
    name: 'tagDialog',
    data() {
        return {
            tag: '',
            item: {},
            rules:{},
            secectedNum: 0,
            secectedList: [],
            taglist: [],
            dialogVisible: false,
            spellTipList: [
                {code: 1, name: '店家推荐', cls: '', isSelected: false},
                {code: 2, name: '粉丝福利', cls: '', isSelected: false},
                {code: 3, name: '新品上市', cls: '', isSelected: false},
                {code: 4, name: '网红爆品', cls: '', isSelected: false},
                {code: 5, name: '今日特卖', cls: '', isSelected: false},
                {code: 6, name: '顺丰包邮', cls: '', isSelected: false}
            ]
        }
    },
    mounted() {
    },
    methods: {
        handelAdd() {
            let flag = false
            if (this.secectedNum >= 2) {
                this.$message.error('最多选择两个标签')
                return false
            }
            this.secectedList.forEach((obj, i) => {
                if (obj == this.tag) {
                    this.$message.error('标签已存在，请重新输入')
                    flag = true
                    return false
                }
            })
            if (flag) return false
            this.taglist.push(this.tag)
            this.secectedNum++
            this.secectedList.push(this.tag)
            this.tag = ''
        },
        handelChange2(tag,index) {
            this.taglist.splice(index, 1)
            this.secectedList.forEach((obj,i) => {
                if (obj == tag) {
                    this.secectedList.splice(i, 1)
                }
            })
            this.secectedNum--
        },
        handelChange(tag,index) {
            if (tag.isSelected) {
                this.secectedList.forEach((obj,i) => {
                    console.log(obj, tag.name)
                    if (obj == tag.name) {
                        this.secectedList.splice(i, 1)
                    }
                })
                this.secectedNum--
            } else {
                let flag = false
                if (this.secectedNum >= 2) {
                    this.$message.error('最多选择两个标签')
                    return false
                }
                this.secectedList.forEach((obj, i) => {
                    if (obj == tag.name) {
                        this.$message.error('标签已存在，请重新输入')
                        flag = true
                        return false
                    }
                })
                if (flag) return false
                this.secectedList.push(tag.name)
                this.secectedNum++
            }
            tag.isSelected = !tag.isSelected
        },
        openDialog(taglist) {
            this.dialogVisible = true
            this.secectedNum = taglist.length
            this.secectedList = this._.cloneDeep(taglist)
            this.taglist = []
            this.spellTipList.forEach(obj => {
                taglist.forEach((obj2, i) => {
                    if (obj.name == obj2) {
                        obj.isSelected = true
                        delete taglist[i]
                    }
                })
            })
            taglist = taglist.filter(obj => obj)
            taglist.forEach(obj => {
                this.taglist.push(obj)
            })
        },
        cancel() {
            this.dialogVisible = false
        },
        submit() {
            if (!this.secectedList.length) {
                this.$message.error('请添加标签')
                return false
            }
            this.$emit('setTaglist', this.secectedList)
            this.cancel()
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.tagDialog {
    .el-dialog .el-dialog__body {
        padding-bottom: 0;
    }
    .form {
        margin-top: 0 !important;
    }
    .el-form-item__label{
        line-height: 32px;
    }
    .label{
        display: flex;
        line-height: 1;
        .el-button{
            margin-bottom: 0;
            margin-left: 20px;
        }
    }
    .taglist {
        display: flex;
        flex-wrap: wrap;
        min-height: 44px;
        .tag {
            padding: 0 16px;
            height: 24px;
            line-height: 24px;
            border: 1px solid #909399;
            box-sizing: border-box;
            color: #909399;
            font-size: 12px;
            cursor: pointer;
            margin-right: 20px;
            margin-bottom: 20px;
        }
        .tag.selected {
            background: #EEF6FF;
            color: #409EFF;
            border: 1px solid #EEF6FF;
        }
    }
}
</style>
